'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var react = require('@chakra-ui/react');
var Circle = react.Circle;
exports.Circle = Circle;